window.jQuery = require('jquery');
//
require('owl.carousel');

// require('venobox');
import VenoBox from '../../node_modules/venobox/dist/venobox';

require('./components/podcast-popup');
require('./components/video-popup');
require('./components/ea-confirm-popup');
require('./components/climb-application-confirm-popup');
require('./components/shared-components-require');
require('./components/unsubscribe');

const Hash = require("./components/hash");

import tutorial from './members/tutorial';

require('bootstrap');
// const MobileDetect = require('mobile-detect');

jQuery(function ($) {
  const owl = $('.owl-carousel');
  owl.owlCarousel({
    nav: false,
    dots: true,
    // loop: true,
    rewind: true,
    video: true,
    items: 1,
    //navText            : ['', ''],
    autoplay: true,
    //navClass           : ['button-arrow prev-slide fa fa-angle-left', 'button-arrow next-slide fa fa-angle-right'],
    //navElement         : 'div role="presentation"',
    autoplayTimeout: 8000,
    //navContainerClass  : 'slider-nav',
    autoplayHoverPause: true,
  });

  if(document.querySelector('.main-container')) {
    document.querySelector('body').style.setProperty('height', window.outerHeight + 'px', 'important');
    document.querySelector('.main-container').style.setProperty('height', document.querySelector('.main-content').getBoundingClientRect().height + 'px', 'important');
    new ResizeObserver(() => {
      document.querySelector('.main-container').style.setProperty('height', document.querySelector('.main-content').getBoundingClientRect().height + 'px', 'important');
    }).observe(document.querySelector('.main-content'));
  }

  const date = new Date();

  if(!window.localStorage.getItem('tutorial-shown') || window.localStorage.getItem('tutorial-shown') === `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`) {
    tutorial.init($);
    window.localStorage.setItem('tutorial-shown', `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
  }

  const chooseEaAwardOnLocation = location => {
    switch(location) {
      case 'inside':
        // $('.eaa-form #award').val('');
        $('.eaa-form #award option').attr('disabled', false);
        $('.eaa-form #award').selectpicker('refresh');
        break;
      case 'outside': 
        $('.eaa-form #award option:not(:nth-child(2))').attr('disabled', 'disabled');
        $('.eaa-form #award').val('Mentorship Pairing #1');
        $('.eaa-form #award').selectpicker('refresh');
        break;
    }
  };

  if($('.eaa-form #location').length && $('.eaa-form #location').val() && $('.eaa-form #location').val().length) {
    chooseEaAwardOnLocation($('.eaa-form #location').val());
  }

  $('.eaa-form #location').on('change', e => {
    const location = e.target.value;

    chooseEaAwardOnLocation(location);
  });

  $('#tutorial-launch').on('click', async e => {
    e.preventDefault();
    e.stopPropagation();
    window.localStorage.removeItem('tutorial-shown');
    await tutorial.completeTour(0);
    window.location.href = e.target.href;
  });


  new VenoBox({
    selector: ".venoboxy",
    autoplay: true,
    onPreOpen: function () {
      owl.trigger('stop.owl.autoplay');
      // console.log('stop.owl.autoplay')
    },
    onPreClose: function () {
      owl.trigger('play.owl.autoplay');
      // console.log('play.owl.autoplay')
    },
  });

  // const mb = new MobileDetect(window.navigator.userAgent);

  $('#profileFields').conditionalFields();

  $('.repeater-fields').repeaterFields();
  const $mainMenu = $('.main-menu');
  $mainMenu.subExpandable();

  $('[data-toggle="tooltip"]').tooltip();

  $(window).on('load', function () {
    $('[data-toggle-tab="' + location.hash.slice(1) + '"]').trigger('click');
  });

  $('[data-js="recipients"]').selectpicker().ajaxSelectPicker({
    ajax: {
      url: `/api/members/${$('[data-js="api_key"]').val()}`,
      data: function () {
        return {q: '{{{q}}}'};
      },
      method: 'get',
      dataType: 'json',
    },
    cache: false,
    locale: {emptyTitle: 'Searching for member...'},
    preprocessData: function (data) {
      let members = [];
      if (data.length) {
        for (let i in data) {
          members.push({
            text: data[i].name,
            value: data[i].id,
          });
        }
      }

      return members;
    },

    // preserveSelected : false
  });

  {
    setTimeout(() => {
      const currentURL = window.location.href;
      $('.sidebar > .level_root').find('a').each((i, el) => {
        if ($(el).attr('href') == currentURL) {
          const $a = $(el);
          $a.addClass('active');
          $a.parents('ul').each((i, el) => {
            $(el).css('display', 'block')
            $(el).parent('li').addClass('active')
          });
        }
      })
    }, 10);
  }

  $('#award').on('change', e => {
    const descriptions = $('#profileFields .description');
    descriptions.each((i, el) => {

      if ($(el).data('descriptions')) {
        const values = $(el).data('descriptions');
        if (values[e.target.value]) {
          $(el).html(values[e.target.value]);
        }
      }
    });

    const titles = $('#profileFields .group-title');
    titles.each((i, el) => {
      const values = $(el).data('titles');
      if (values) {
        if (values[e.target.value]) {
          $(el).find('span.title-text').html(values[e.target.value]);
        }
      }
    });

  });

  setTimeout(() => {
    $('#award').trigger('change');
  }, 100);

  setTimeout(() => {
    $("#sub_specialty option:contains('Other')").insertAfter($("#sub_specialty option:last"));
    $('#sub_specialty').selectpicker('refresh');

    $("#specialty option:contains('Current Cardiology Fellow in Training')").remove();
    $('#specialty').selectpicker('refresh');
  }, 500);


  // if ($('#pdfContainer').length) {
  //     const pdfFile = $('#pdfContainer').data('pdf-file');
  //     PDFObject.embed(pdfFile, "#pdfContainer");
  // }

  $('.register #password, .reset-pass #password').password({
    // shortPass            : 'The password is too short',
    // badPass              : 'Weak; try combining letters & numbers',
    // goodPass             : 'Medium; try using special charecters',
    // strongPass           : 'Strong password',
    // containsUsername     : 'The password contains the username',
    // enterPass            : 'Type your password',
    // showPercent          : false,
    // showText             : true, // shows the text tips
    // animate              : true, // whether or not to animate the progress bar on input blur/focus
    // animateSpeed         : 'fast', // the above animation speed
    // username             : false, // select the username field (selector or jQuery instance) for better password checks
    // usernamePartialMatch : true, // whether to check for username partials
    // minimumLength        : 4 // minimum password length (below this threshold, the score is 0)
  });

  // if (Hash.val &&) {
  //     $(this).tab('show')
  // }

  // $('.year-mask').mask('MCDY', {
  //     'translation' : {
  //         M : {pattern : /[1-2]/},
  //         C : {pattern : /[0-9]/},
  //         D : {pattern : /[0-9]/},
  //         Y : {pattern : /[0-9]/},
  //     }
  // });
  // {
  //     const options = {
  //         onKeyPress : function (cep, e, field, options) {
  //             const translation = {
  //                 firstM  : {
  //                     C : {pattern : /[2-9]/},
  //                 },
  //                 secondM : {
  //                     C : {pattern : /[0]/},
  //                 }
  //             };
  //             console.log(cep);
  //             const mask        = (cep.length > 7) ? translation[1] : translation[0];
  //
  //             $('.year-mask').mask(mask, options);
  //         }
  //     };
  //
  //     $('.year-mask').mask('00000-000', options);
  // }
  {
    /* attach a submit handler to the form */
    // $(".cv-category-form").submit(function (event) {
    //
    //     /* stop form from submitting normally */
    //     event.preventDefault();
    //
    //     /* get the action attribute from the <form action=""> element */
    //     var $form = $(this),
    //         url   = $form.attr('action');
    //
    //     /* Send the data using post with element id name and name2*/
    //     var posting = $.post(url, {name : $('#name').val(), name2 : $('#name2').val()});
    //
    //     /* Alerts the results */
    //     posting.done(function (data) {
    //         alert('success');
    //     });
    // });

    $('form[method="get"]').on('submit', function () {
      $(this).find(':input').each(function () {
        if ($(this).val() == '') {
          $(this).prop('disabled', true);
        }
      })
    });
  }

  // CV
  {
    const cgSelector = '.cv-category-group',
      categoryGroup = $(cgSelector);

    categoryGroup.find('.category-select').on('change', function () {
      const val = $(this).val();
      const thisCG = $(this).closest(cgSelector);
      const hidden = thisCG.find('.category-hidden');
      // console.log(thisCG);
      // console.log(val);
      // console.log(thisCG.find('.record-regular :input'));

      if (val == 'Misc') {
        thisCG.find('.record-regular :input').prop('disabled', true);
        thisCG.find('.record-regular').hide();
        thisCG.find('.record-misc').show();
        thisCG.find('.misc-title').prop('disabled', false);
      } else {
        thisCG.find('.record-regular :input').prop('disabled', false);
        thisCG.find('.record-regular').show();
        thisCG.find('.record-misc').hide();
        thisCG.find('.misc-title').prop('disabled', true);
      }

      hidden.val(val);
    }).trigger('change');
  }

  // Mobile menu
  {
    $('.mobile-menu-toggle').on('click', function () {
      if($('.mobile-activity').hasClass('activity-open')) {
        $('.nav-item.notification').trigger('click');
      }

      $(this).toggleClass('open');
      $($(this).data('menu')).toggleClass('open');
    });
  }

  //messages

  {
    $('.message-link').on('click', function (e) {
      $(e.currentTarget).closest('.nav-messages').find('.wrap-link').removeClass('current-folder');
      $(e.currentTarget).closest('.wrap-link').addClass('current-folder');
      $('#' + $(this).attr('data-toggle-tab')).addClass('active').siblings().removeClass('active');
    });
  }

  {
    // $('.message-row').on('click', e => {
    //   e.preventDefault();
    //
    //   $('.active-message').removeClass('active-message');
    //   const $messageRow = $(e.currentTarget);
    //   $messageRow.addClass('active-message');
    //   const $messageDetail = $messageRow.closest('.tab-pane').find('.full-message');
    //   $messageDetail.removeClass('d-none');
    //
    //   $messageDetail.find('.message-detail-subject').text($messageRow.find('.subject a').text());
    //   $messageDetail.find('.message-detail-sender-name').text($messageRow.find('.message-from-name').text());
    //   $messageDetail.find('.message-detail-body-text').html($messageRow.find('.message-body').html());
    // });
  }

  {
    setTimeout(function () {
      $('.vc_tta-panel-title > a').off().on('click', event => {
        const $activePanel = $(event.currentTarget).closest('.vc_tta-panel.vc_active');
        if ($activePanel.length) {
          event.preventDefault();
          event.stopPropagation();
          $activePanel.find('.vc_tta-panel-body').slideToggle();
          setTimeout(() => {
            $activePanel.removeClass('vc_active');
          }, 300);
        }
      });
    }, 50);
  }

  {
    if($('[data-profile-tab]').length) {
      const setTitle = profileId => {
        if(profileId == 1) {
          $('title').text('TD - My Settings');
        } else {
          $('title').text('TD - My Profile');
        }
      };
      const active_tab = window.location.hash.replace('#tab-', '') || _edit_profile_active_tab;
      const setActiveProfile = profileId => {
        if (profileId) {
          setTitle(profileId);
          $('.profile-tab').removeClass("active");
          $('.profile-tab-content').removeClass('active');
          $(`.profile-tab:nth-child(${profileId})`).addClass('active');
          $(`.profile-content-${profileId}`).addClass('active');
        }
      };

      window.addEventListener("hashchange", (event) => {
        setActiveProfile(event.target.Hash.val.replace('tab-', ''));
      }, false);

      setActiveProfile(active_tab);

      $('[data-profile-tab]').on('click', function () {
        window.location.hash = `#tab-${$(this).index() + 1}`
      });

      $('[data-target-tab]').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const tabTarget = $(event.currentTarget).data('targetTab');
        if (tabTarget !== undefined && parseInt(tabTarget) > 0) {
          if (event.currentTarget.tagName === 'A') {
            const dsq = `d=${new Date().getTime()}`;
            // const search = (location.search.length === 0 ? dsq : (location.search + '&' + dsq));
            location.href = `${event.currentTarget.href}?${dsq}#tab-${tabTarget}`
            return;
          }
          window.location.hash = `#tab-${tabTarget}`;
          window.scrollTo({
            top: 90,
            behavior: "smooth"
          });
        }
      });
    }

    /**
     * Need to remove validation of this field to allow them to submit the form
     */
    // $('#submit_4').on('click', e => {
    //   if (!$('#cv_pdf').first().val().length && !$('#pdfContainer').length) {
    //     e.preventDefault();
    //     $('#cv-pdf-error').removeClass('d-none');
    //   }
    // });
  }
  {
    $('.spec-sub-activity .latest-activity-wrapper').fadeOut();
    $('.spec-sub-activity a[data-target]').on('click', e => {
      $('.spec-sub-activity a[data-target]').removeClass('active');
      const target = $(e.target).data('target');
      const selector = `.spec-sub-activity .latest-${target}-wrapper`;
      $('.spec-sub-activity .latest-notify').fadeOut();
      $(selector).fadeIn();
      $(e.target).addClass('active');
    });

    $('.nav-item.notification, .notify-see-more').on('click', e => {
      e.preventDefault();
      e.stopPropagation();

      if(window.innerWidth < 768) {
        $('.mobile-activity').toggleClass('activity-open');
        resetUnreadNotificationsCount();
        $('.main-container').removeClass('open');
        $('.mobile-menu-toggle').removeClass('open');
        window.scrollTo({ top: 0});
      } else {
        $('a[data-spec-sub="activity"]').trigger('click');
      }
    })
  }
  {
    const $doc = $('body');
    const INTRO_POPUP_KEY = 'user-intro-seen-2022';
    if ($doc.hasClass('admin-member-area') && $doc.find('.dashboard').length && $doc.find('.popup-instruction').length) {
      let numberstep = 1;
      const userIntroSeen = localStorage.getItem(INTRO_POPUP_KEY);
      if (userIntroSeen === 'yes') {
        $doc.removeClass('first-time-instruction');
      } else {
        $doc.addClass(`first-time-instruction step${numberstep}`);
      }

      const makeUserSeenIntro = (value) => {
        localStorage.setItem(INTRO_POPUP_KEY, value);
        $doc.removeClass('first-time-instruction');
      };

      $('.instruction-close.instruction-button').on('click', () => {
        makeUserSeenIntro('yes');
      });

      $('.instruction-close.x-button').on('click', () => {
        // $doc.removeClass('first-time-instruction');
        makeUserSeenIntro('yes');
      });

      $('.instruction-next').on('click', () => {
        $('.first-time-instruction').removeClass('step' + numberstep);
        numberstep += 1;
        $('.first-time-instruction').addClass('step' + numberstep);
      });

    }
  }

  {
    const $form = $('#profileFields');
    const $input_fields = $form.find('input');
    const $select_fields = $form.find('select');

    const profileFormFieldEventHandler = event => {
      const $section = $(event.currentTarget).closest('.profile-tab-content');
      const id = $section.data('tabId');
      $(`#${id}`).val($section.data('tabName'));
    };
    // let prev_values = new Map();
    // $input_fields.each((k, el) => {
    //     if(type == 'checkbox' && checked == true) {
    //
    //         prev_values.set( el.name, el.value );
    //     }
    //
    // });
    // console.log(prev_values);
    $input_fields.on('input', profileFormFieldEventHandler);

    $select_fields.on('change', profileFormFieldEventHandler);
  }

  {
    if ($('[name="track_selection"]:checked').length) {
      $('.climb-app-help-text').slideDown();
    }
    $('[name="track_selection"]').on('change', e => {
      $('.climb-app-help-text').slideDown();
    });

    setTimeout(() => {
      const $track_subselection = $('#track_subselection').val();

      if ($track_subselection) {
        const data = JSON.parse($track_subselection);

        if (data && data.length) {
          $('.track_subselection')
            .closest('.form-group:visible')
            .map((i, el) => {
              if (data[i]) {
                $(el).find('.track_subselection').val(data[i]);
                $(el).find('.track_subselection').selectpicker('refresh');
              }
            });
        }
      }
    }, 1000);
  }

  {
    $('.climb-app-form form .selectpicker').on('change', e => {
      $(e.target).closest('form').find('.selectpicker').each((i, el) => {
        const $closestWrapper = $(el).closest('.form-group');
        if ($closestWrapper.is(':hidden') || e.target.id == 'pathway') {
          let $sp = $closestWrapper.find('.selectpicker');
          if (e.target.id == 'pathway' && $sp.attr('id') == 'pathway') {
            return;
          }
          $sp.val('');
          $sp.selectpicker('refresh');
        }
      });
    });
  }

  $(".read-more").on("click", function () {
    o = $(this).parents("span"), n = o.find(".info"),
      o.hasClass("active_block") ? (o.removeClass("active_block"), n.slideUp()) : (o.addClass("active_block"), n.stop(!0, !0).slideDown(), n.css('display', 'inline-block'), o.siblings(".active_block").removeClass("active_block").find(".info").slideUp()),
      o[0].scrollIntoView()
  });



  /* Compare inputs for email confirm */
  const newEmail = $("#newEmail").on('keyup', validateIdentity),
    newEmailConf = $("#newEmailConf").on('keyup', validateIdentity);

  function validateIdentity() {
    let msg = newEmail.val() !== newEmailConf.val() ? "Emails Don't Match" : '';
    newEmailConf.get(0).setCustomValidity(msg);
  }

  /* Special submenu item */
  const
    menuItems = $mainMenu.find('.menu_item'),
    currentMenuItem = $mainMenu.find('.menu_item.current'),
    specSubMenuItem = $('.level_root [data-spec-sub]');

  if (specSubMenuItem.length) {
    specSubMenuItem.on('click', function (e) {
      e.preventDefault();
      const $this = $(this);
      menuItems.removeClass('current');
      $this.parent().addClass('current');
      let specSubBox = $('.spec-sub-' + $this.data('spec-sub'));
      specSubBox.fadeIn();
      resetUnreadNotificationsCount();
    });

    $(document).mouseup(function (e) {
      if (specSubMenuItem.parent().hasClass('current')) {
        const cont = $('.spec-sub-cont');
        if (!cont.is(e.target) && cont.has(e.target).length === 0) {
          cont.parents('.spec-sub').fadeOut();
          currentMenuItem.addClass('current');
          specSubMenuItem.parent().removeClass('current')
        }
      }
    });
  }

  const resetUnreadNotificationsCount = () => {
    if(document.querySelector('.notification .fa-bell ').hasAttribute('data-badge')) {
      return fetch(`/auth/members/alerts-set-seen`, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify({})
      })
      .then(response => response.json())
      .then( data => {
        if(data.success == true) {
          document.querySelector('.notification .fa-bell ').removeAttribute('data-badge');
        }
      } );
    }
  };

  $('label[data-html]').each((i, label) => {
    const $label = $(label);
    $label.append($label.data('html'));
  });

  /* new VenoBox({
     selector: '.venobox-gallery',
   });*/

  // Venobox
  /*$('.venoboxy, .test').venobox({
    // autoplay: true
  });*/
  {
    // $('[data-wp-fetch]').each((i, el) => {
    //   console.log($(el).data('wp-fetch'));
    //   $.get('/api/wp-get?url=' + $(el).data('wp-fetch'), 
    //     function(result) {
    //       if(result && result.length) {
    //         const data = JSON.parse(result);
    //         if(data.length) {
    //           $(el).html(data[0].content.rendered)
    //         }
    //       }
    //     }
    //   ).always(function() {
    //     console.log('always');
    //   });
    // });
  }

});
